class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

        updateOfferCollectionCartTotal();
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    updateOfferCollectionCartTotal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

/**
 * Shows a "Great, you have done it!" popup when offer threshold is reached,
 * with the single product from the offer theme setting.
 */
function showThresholdReachedPopup() {
  let overlay = document.getElementById('offer-threshold-popup');
  if (overlay) return;

  const cardContainer = document.getElementById('offer-product-card');
  const productBlock = cardContainer ? cardContainer.innerHTML : '';

  overlay = document.createElement('div');
  overlay.id = 'offer-threshold-popup';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-labelledby', 'offer-threshold-popup-title');
  overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.4);animation:fadeIn 0.2s ease;';
  overlay.innerHTML = `
    <div style="position:relative;background:#fff;color:#000;padding:1.5rem 2rem;border-radius:8px;max-width:90%;text-align:center;box-shadow:0 4px 20px rgba(0,0,0,0.15);">
      <button type="button" data-close-threshold-popup aria-label="Close" style="position:absolute;top:0.75rem;right:0.75rem;width:2rem;height:2rem;padding:0;border:none;background:transparent;cursor:pointer;color:#000;font-size:1.5rem;line-height:1;display:flex;align-items:center;justify-content:center;">&times;</button>
      <p id="offer-threshold-popup-title" style="margin:0 0 0.5rem;font-size:1.25rem;font-weight:600;">Great, you have done it!</p>
      <div class="offer-product-card-wrapper">
        ${productBlock}
      </div>
    </div>
  `;

  const close = () => {
    overlay.remove();
    document.body.style.overflow = '';
    // Clean up all listeners
    ['cart:updated', 'cart:refresh', 'cart:change', 'cartUpdate'].forEach(evt => {
      document.removeEventListener(evt, close);
    });
  };

  overlay.querySelector('[data-close-threshold-popup]').addEventListener('click', close);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });

  // Listen for all possible cart event names your theme might use
  ['cart:updated', 'cart:refresh', 'cart:change', 'cartUpdate'].forEach(evt => {
    document.addEventListener(evt, close);
  });

  // Intercept the add-to-cart button click directly as fallback
  overlay.querySelectorAll('add-to-cart').forEach(btn => {
    btn.addEventListener('click', () => {
      // Wait for cart fetch to complete then close
      setTimeout(close, 1500);
    });
  });

  document.body.style.overflow = 'hidden';
  document.body.appendChild(overlay);

  const priceContainer = overlay.querySelector('.price');
  if (priceContainer) {
    const actualPrice = priceContainer.innerHTML;

    priceContainer.innerHTML = `
      <span class="price-item--regular" style="text-decoration:line-through;">
        ${actualPrice}
      </span>
      <span class="price-item price-item--sale" style="font-weight:600;margin-left:6px; margin-top:2px;">
        ₹1
      </span>
    `;
  }

  const priceContainer1 = overlay.querySelector('.price-item--regular .price__regular');
  if (priceContainer1) {
    priceContainer1.style.textDecoration = 'line-through';
    priceContainer1.style.color = '#8f8f8f';
  }
  // Force prog-picture images to load
  overlay.querySelectorAll('picture[is="prog-picture"]').forEach(picture => {
    const hqSrc = picture.getAttribute('data-hq');
    const img = picture.querySelector('img');
    if (img && hqSrc) img.src = hqSrc;
  });
}

const CART_SECTIONS = ['mini-cart', 'cart-drawer', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

/**
 * Fetches cart sections and updates the DOM so mini cart reflects current cart without page refresh.
 */
async function refreshCartSections() {
  const sectionResponse = await fetch(`/cart?sections=${CART_SECTIONS.join(',')}`);
  const sectionsJSON = await sectionResponse.json();
  CART_SECTIONS.forEach((id) => {
    const el = document.getElementById(id);
    if (el && sectionsJSON[id]) {
      el.innerHTML = new DOMParser()
        .parseFromString(sectionsJSON[id], 'text/html')
        .querySelector('.shopify-section').innerHTML;
    }
  });
  await updateOfferCollectionCartTotal();
}

/**
 * Reads server-computed offer total from the form (works for collections of any size).
 * Shows popup only if threshold reached and offer product not already in cart.
 * If threshold not reached, removes the offer product from cart.
 */
async function updateOfferCollectionCartTotal() {
  const cartForm = document.getElementById('cart');
  if (!cartForm) return;

  const offerCollectionTotalCents = Number(cartForm.getAttribute('data-offer-collection-total')) || 0;
  const threshold = Number(cartForm.getAttribute('data-offer-threshold')) || 0;
  const offerProductInCart = cartForm.getAttribute('data-offer-product-in-cart') === '1';
  const lineKeysStr = cartForm.getAttribute('data-offer-product-line-keys') || '';
  const offerProductLineKeys = lineKeysStr ? lineKeysStr.split(',').map((k) => k.trim()).filter(Boolean) : [];

  const totalInUnits = offerCollectionTotalCents / 100;

  if (threshold > 0 && totalInUnits < threshold) {
    if (offerProductInCart && offerProductLineKeys.length > 0) {
      for (const key of offerProductLineKeys) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        });
      }
      await refreshCartSections();
    }
    return;
  }

  if (threshold > 0 && totalInUnits >= threshold && !offerProductInCart) {
    showThresholdReachedPopup();
  }
}

customElements.define('mini-cart', MiniCart);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    const input = this.querySelector('input[name="discount"]');
    const button = this.querySelector('button');

    if (input) {
      input.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.applyDiscount();
        }
      });
    }

    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.applyDiscount();
      });
    }
  }

  async applyDiscount() {
    const input = this.querySelector('input[name="discount"]');
    const message = this.querySelector('.discount-message');
    if (!input || !message) return;

    const code = input.value.trim();
    if (!code) {
      message.textContent = 'Please enter a discount code.';
      message.classList.add('error');
      return;
    }

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ discount: code }),
        credentials: 'include',
      });

      const data = await response.json();
      console.log('Cart update response:', data);

      if (!data.discount_codes?.length || data.discount_codes[0].applicable === false) {
        message.textContent = 'Invalid or inapplicable discount code.';
        message.classList.add('error');
        message.classList.remove('success');
        return; 
      }

      message.textContent = 'Discount code applied successfully!';
      message.classList.remove('error');
      message.classList.add('success');

      const sections = [
        'mini-cart',
        'cart-drawer',
        'cart-icon-bubble',
        'mobile-cart-icon-bubble'
      ];

      const sectionResponse = await fetch(`/cart?sections=${sections.join(',')}`);
      const sectionsJSON = await sectionResponse.json();

      sections.forEach((id) => {
        const el = document.getElementById(id);
        if (el && sectionsJSON[id]) {
          el.innerHTML = new DOMParser()
            .parseFromString(sectionsJSON[id], 'text/html')
            .querySelector('.shopify-section').innerHTML;
        }
      });

      updateOfferCollectionCartTotal();
      const miniCart = document.querySelector('mini-cart');
      if (miniCart) miniCart.open();

    } catch (err) {
      message.textContent = 'Something went wrong. Please try again.';
      message.classList.add('error');
      console.error(err);
    }
  }
}

customElements.define('discount-code', DiscountCode);

document.addEventListener('cart:updated', () => {
  refreshCartSections();
});

document.addEventListener('click', async (e) => {
  if (e.target.classList.contains('remove-discount')) {
    e.preventDefault();

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ discount: "" }),
        credentials: 'include',
      });

      const data = await response.json();
      console.log('Discount removed:', data);

      const sections = [
        'mini-cart',
        'cart-drawer',
        'cart-icon-bubble',
        'mobile-cart-icon-bubble'
      ];
      const sectionResponse = await fetch(`/cart?sections=${sections.join(',')}`);
      const sectionsJSON = await sectionResponse.json();

      sections.forEach((id) => {
        const el = document.getElementById(id);
        if (el && sectionsJSON[id]) {
          el.innerHTML = new DOMParser()
            .parseFromString(sectionsJSON[id], 'text/html')
            .querySelector('.shopify-section').innerHTML;
        }
      });

      updateOfferCollectionCartTotal();
      const miniCart = document.querySelector('mini-cart');
      if (miniCart) miniCart.open();

    } catch (err) {
      console.error('Error removing discount:', err);
    }
  }
});

